import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { Cluster } from 'src/app/models/cluster.model';
import { InvestableParameters } from 'src/app/models/investable-parameters.model';

import { ClustersService } from 'src/app/services/clusters.service';
import { InvestableService } from 'src/app/services/investable.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-investable-implement',
  templateUrl: './investable-implement.component.html',
  styleUrls: ['./investable-implement.component.scss']
})
export class InvestableImplementComponent implements OnInit, OnDestroy {

  @Input() isComputing!: boolean;
  @Output() isComputingChange = new EventEmitter<boolean>();

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;

  investableParameters: InvestableParameters;
  investableParametersSubscription: Subscription;

  constructor(private router: Router,
              private clustersService: ClustersService,
              private investableService: InvestableService,
              private notificationsService: NotificationsService,) { }

  ngOnInit(): void {
    this.subscribeToCurrentCluster();
    this.subscribeToInvestableParameters();
  }

  ngOnDestroy() {
    if (this.currentClusterSubscription != undefined) { this.currentClusterSubscription.unsubscribe(); }
    if (this.investableParametersSubscription != undefined) { this.investableParametersSubscription.unsubscribe(); }
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        if (cluster!=undefined) {
          this.currentCluster = cluster;
        }
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToInvestableParameters() {
    this.investableParametersSubscription = this.investableService.investableParametersSubject.subscribe(
      (investableParameters: InvestableParameters) => {
        this.investableParameters = investableParameters;
      }
    );
    this.investableService.emitInvestableParameters();
  }

  async implement(redirect?: string) {
    this.notificationsService.runSpinner();
    this.setIsComputing(true);

    try {
      await this.investableService.computeCustomInvestable(this.investableParameters, this.currentCluster, true);
      await this.clustersService.select(this.currentCluster.id);
      if (redirect != undefined) {
        this.setIsComputing(false);
        this.notificationsService.stopSpinner();
        this.router.navigate([redirect]);
      }
    }
    catch(e) {
      this.notificationsService.notify('investable/create-failed');
    }

    this.setIsComputing(false);
    this.notificationsService.stopSpinner();
  }

  async implementAndGoToAnalytics() {
    await this.implement('/tools/analytics');
  }

  async implementAndProtectPortfolio() {
    await this.implement('/tools/risk-management');
  }

  setIsComputing(flag: boolean) {
    if (this.isComputing != flag) {
      this.isComputing = flag;
      this.isComputingChange.emit(flag);
    }
  }

}
